import { render, staticRenderFns } from "./WindowMain.vue?vue&type=template&id=373ffc3b"
import script from "./WindowMain.vue?vue&type=script&lang=js"
export * from "./WindowMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports